import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_mst_item_attribute_child_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  fi_item_line_guid: fromDatatype.GuidDataFieldInterface;
  attribute_set_hdr_guid: fromDatatype.GuidDataFieldInterface;
  attribute_hdr_guid: fromDatatype.GuidDataFieldInterface;
  attribute_code: fromDatatype.TextDatatypeInterface;
  attribute_name: fromDatatype.TextDatatypeInterface;
  source_type: fromDatatype.TextDatatypeInterface;
  value_type: fromDatatype.TextDatatypeInterface;
  value_string: fromDatatype.TextDatatypeInterface;
  value_numeric: fromDatatype.NumericDatatypeInterface;
  value_datetime: fromDatatype.TimestampTzDatatypeInterface;
  value_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  ecomsync_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  ecomsync_item_line_guid: fromDatatype.GuidDataFieldInterface;
  sequence_no: fromDatatype.NumericDatatypeInterface;
  is_viewable: boolean;
}

export class bl_fi_mst_item_attribute_child_link_RowClass
  implements bl_fi_mst_item_attribute_child_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
  fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  fi_item_line_guid: fromDatatype.GuidDataFieldInterface;
  attribute_set_hdr_guid: fromDatatype.GuidDataFieldInterface;
  attribute_hdr_guid: fromDatatype.GuidDataFieldInterface;
  attribute_code: fromDatatype.TextDatatypeInterface;
  attribute_name: fromDatatype.TextDatatypeInterface;
  source_type: fromDatatype.TextDatatypeInterface;
  value_type: fromDatatype.TextDatatypeInterface;
  value_string: fromDatatype.TextDatatypeInterface;
  value_numeric: fromDatatype.NumericDatatypeInterface;
  value_datetime: fromDatatype.TimestampTzDatatypeInterface;
  value_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  ecomsync_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  ecomsync_item_line_guid: fromDatatype.GuidDataFieldInterface;
  sequence_no: fromDatatype.NumericDatatypeInterface;
  is_viewable: boolean;
}
